import { useTranslation } from "react-i18next";

import { useTutorialStore } from "../model/store/useTutorialStore";

import cls from "./TutorialButton.module.css";

import { useSessionStore } from "@/entities/session/models/store/useSessionStore";

export const TutorialButton = ({ "data-qa": dataQa }: { "data-qa"?: string }) => {
    const { t } = useTranslation();
    const isCompleted = useSessionStore((state) => Boolean(state.accountInfo?.tutorial_completed));
    const { isOpen, open } = useTutorialStore();

    if (!isCompleted || isOpen) return null;

    return (
        <button
            type="button"
            className={cls.button}
            onClick={open}
            title={t("tutorial.header-button-hint")}
            data-qa={dataQa}
        >
            {t("tutorial.header-button")}
        </button>
    );
};
